<template>
  <div class="home inner-page inner-page--synak-intro">
    <!--~~~~~     PAGE HEADER     ~~~~~-->
    <header class="inner-page__header">

      <div class="container">

        <div class="row  justify-content-between  align-items-center">

          <div class="inner-page__logo  col">
            <div class="logo">
              <router-link class="logo__link" :to="{name:'admin.login'}">
                <img src="@/assets/img/logo__ekyzmat-full--light.svg" alt="EKYZMAT">
                <span class="logo__descr">{{ getTranslation('testing') }}</span>
              </router-link>
            </div>
          </div>

          <div class="inner-page__right">

            <div class="inner-page__lang">
              <ul class="lang-switcher">
                <li v-for="locale in locales" class="lang-switcher__item">
                                  <span :title="$lang.app[locale.title]">
                                    <a @click="changeLocale(locale.title)" class="lang-switcher__link" :class="{'lang-switcher__link--active': locale.title === currentLocale }" href="javascript:void(0)">{{ $lang.locale[locale.title] }}</a>
                                  </span>
                </li>
              </ul>
            </div>
          </div>

        </div>
        <!-- /row -->

      </div>
      <!-- /container -->

    </header>
    <!--~~~~~     / PAGE HEADER     ~~~~~-->
    <!--~~~~~     PAGE CONTENT     ~~~~~-->
    <main class="inner-page__content">

      <div v-if="!showSpinner" class="container">
        <div v-if="authenticationFailed" class="row">
          <div v-if="showError" class="col-sm-6  col-xl-6 m-auto">
            <div class="alert">
              <div class="alert__header">
                <svg class="alert__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 54 54">
                  <circle cx="27" cy="27" r="25" fill="none" stroke="#EB2626" stroke-miterlimit="10" stroke-width="4" />
                  <path fill="#EB2626"
                        d="M29.83,27l6.72-6.72a1,1,0,0,0,0-1.41l-1.41-1.41a1,1,0,0,0-1.41,0L27,24.17l-6.72-6.72a1,1,0,0,0-1.41,0l-1.41,1.41a1,1,0,0,0,0,1.41L24.17,27l-6.72,6.72a1,1,0,0,0,0,1.41l1.41,1.41a1,1,0,0,0,1.41,0L27,29.83l6.72,6.72a1,1,0,0,0,1.41,0l1.41-1.41a1,1,0,0,0,0-1.41Z" />
                </svg>

              </div>

              <div class="alert__body  alert__body--space-top">
                <h3 class="alert__title">{{ getTranslation('error') }}</h3>

                <div class="alert__text font-weight-bold">{{ this.errorDescription }}</div>

                <div class="alert__actions">
                  <a href="javascript:void(0)" @click="closeError" class="btn  btn--danger">{{ getTranslation('close') }}</a>
                </div>
              </div>

              <button @click="closeError" class="alert__close">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.9 21.9">
                  <path
                      d="M14.1 11.3c-.2-.2-.2-.5 0-.7l7.5-7.5c.2-.2.3-.5.3-.7s-.1-.5-.3-.7L20.2.3c-.2-.2-.5-.3-.7-.3-.3 0-.5.1-.7.3l-7.5 7.5c-.2.2-.5.2-.7 0L3.1.3C2.9.1 2.6 0 2.4 0s-.5.1-.7.3L.3 1.7c-.2.2-.3.5-.3.7s.1.5.3.7l7.5 7.5c.2.2.2.5 0 .7L.3 18.8c-.2.2-.3.5-.3.7s.1.5.3.7l1.4 1.4c.2.2.5.3.7.3s.5-.1.7-.3l7.5-7.5c.2-.2.5-.2.7 0l7.5 7.5c.2.2.5.3.7.3s.5-.1.7-.3l1.4-1.4c.2-.2.3-.5.3-.7s-.1-.5-.3-.7l-7.5-7.5z" />
                </svg>
              </button>
            </div>
            <!-- /alert-->

          </div>
        </div>
        <div class="inner-page__intro-heading">
          <h1 class="inner-page__title">{{ getTranslation('testing') }}</h1>
          <div class="inner-page__descr">{{ getTranslation('appDescription') }}</div>
          <a class="btn  btn--lg  btn--main  mb-0" @click="authEkyzmat" href="javascript:void(0)">{{ getTranslation('EkyzmatAuth') }}</a>
        </div>
      </div>
      <div v-else class="container">
        <span class="loading"> {{ getTranslation('loading') }}</span>
      </div>
      <!-- /container -->

    </main>
    <!--~~~~~     / PAGE CONTENT     ~~~~~-->

    <!--~~~~~     PAGE FOOTER     ~~~~~-->
    <footer class="page-footer  page-footer--transparent">

      <div class="container">
        <div class="page-footer__copyright">
          Разработчик: <a href="https://infocom.kg/">Государственное предприятие «Инфоком»</a> <br>
          © Зарегистрирован в Государственном реестре программ для ЭВМ Кыргызской Республики от 26.09.2018 года, сертификат за № 525
        </div>
      </div>
      <!-- /container -->

    </footer>
    <!--~~~~~     / PAGE FOOTER     ~~~~~-->
  </div>
</template>

<script>

export default {
  name: 'adminLogin',
  data() {
    return {
      authCode: '',
      isAuthenticated: false,
      showSpinner: false,
      authenticationFailed: false,
      errorDesc: '',
      showError: false,
      locales: [],
    };
  },
  updated() {
    this.setHeadings({
      title: this.getTranslation('testing'),
    });
  },
  created() {

    if ( !this.getUserToken(false) )
      this.setAxiosAuthorization();

    this.fetchAuthOptions().then(() => {
      if ( this.authFail ) {
        this.handleError();
      } else if ( this.ekyzmatCode ) {
        this.showSpinner = true;
        setTimeout(() => {
          this.authorize();
        }, 1500);
      }
    });
    this.fetchLocales();
  },

  computed: {
    ekyzmatCode() {
      return this.$route.query.code;
    },
    authFail() {
      return this.$route.query.error;
    },
    errorDescription() {
      return this.errorDesc;
    },
  },

  methods: {
    fetchAuthOptions() {
      return this.axios.get(this.$config.urls.auth.fetchAuthOptions.url).then(response => {
        this.authCode = response.data.data.authorizeUrl;
      });
    },
    handleError() {
      this.authenticationFailed = true;
      this.showError = true;
      this.errorDesc = this.$route.query.error_description;
    },
    closeError() {
      this.showError = false;
    },
    authEkyzmat() {
      if ( this.authCode )
        window.location.href = this.authCode;
      else
        this.fetchAuthOptions().then(() => {
          if ( !this.authCode )
            this.snotifyError('serverError');
        }).catch(() => {
          this.snotifyError('serverError');
        });

    },
    authorize() {
      return this.axios.get(this.$config.urls.auth.loginEkyzmat.url, { params: { code: this.ekyzmatCode } }).then(response => {
        this.isAuthenticated = true;
        localStorage.setItem('auth_token', response.data.data.token);
        this.axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.data.token;
        this.loadUser();
        this.$router.push({ name: 'api.home' }).catch(() => {});
      }).catch(() => {
        this.isAuthenticated = false;
        this.showSpinner = false;
        this.snotifyError('serverError');
      });
    },
  },

};
</script>
<style scoped>
.loading {
  font-size: 20px;
  color: #f7faff;
}
</style>
